import { gql } from 'graphql-tag'

const questionFragment = gql`
  fragment QuestionFragment on Question {
    id
    question
    active
  }
`

export const getStationQuestions = gql`
  query GetStationQuestions($stationId: ID!) {
    getStationQuestions(stationId: $stationId) {
      ...QuestionFragment
    }
  }
  ${questionFragment}
`

export const createQuestionMutation = gql`
  mutation CreateQuestion($stationId: ID!, $data: CreateQuestionInputType!) {
    createQuestion(stationId: $stationId, data: $data) {
      ...QuestionFragment
    }
  }
  ${questionFragment}
`

export const updateQuestionMutation = gql`
  mutation UpdateQuestionMutation($id: ID!, $data: UpdateQuestionInputType) {
    updateQuestionMutation(id: $id, data: $data) {
      ...QuestionFragment
    }
  }
  ${questionFragment}
`

export const deleteQuestionMutation = gql`
  mutation DeleteQuestionMutation($id: ID!) {
    deleteQuestionMutation(id: $id)
  }
`
